import animationFrames from 'callbag-animation-frames';
import flatten from 'callbag-flatten';
import lazy from 'callbag-lazy';
import map from 'callbag-map';
import 'callbag-share';

var index = /*#__PURE__*/
flatten(
/*#__PURE__*/
lazy(function () {
  var start = Date.now();
  return map(function () {
    return Date.now() - start;
  })(animationFrames);
}));

export default index;



//////////////////
// WEBPACK FOOTER
// ./node_modules/callbag-ms-elapsed/dist/callbag-ms-elapsed.esm.js
// module id = 629
// module chunks = 0